import React, {
  ReactElement,
  useState,
  useEffect,
  useMemo,
  useRef
} from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import axios from 'axios';
import check from '@assets/check.png';
import Toast from '@xpeng/rc-toast';
import arrow from '@assets/arrow-not-checked.png';
import { FileDto } from '../../../../components/uploade/index';
import Uploade from '../../../../components/uploade';
import CityPicker from '../../../../components/city-picker/index';
import { TArea } from '../../../../components/city-picker';
import {
  createAfterSaleOrder,
  getAfterSalePreInfo,
  queryWarrantyStatus,
  searchPileList
} from '../../../../api/pile-apply';
import {
  getLoginInfoPromise,
  go2LoginIfNot,
  closeWindow,
  getPlatform,
  openUrl,
  getAmapHost
} from '../../../../utils/common';
import Confirm from '../../../../components/confirm';
import FullLoading from '../../../../components/full-loading';
import { PHONE_REG } from "../../../../utils/reg"
import './index.less';

const AfterSales = (): ReactElement => {
  const scrollTop = 1500;
  const [loading, setLoading] = useState<boolean>(false);
  const [uid, setAuthForMX] = useState<any>('');
  const [nickname, setNickname] = useState<string>('');
  const [pileLightStatus, setPileLightStatus] = useState<number>();
  const [problemType, setProblemType] = useState<number>();
  const [problemDesc, setProblemDesc] = useState<string>('');
  const [isFoldProblem, setIsFoldProblem] = useState<boolean>(true);
  const [contactName, setContactName] = useState<string>('');
  const [contactPhone, setContactPhone] = useState<string>('');

  const [areaAddress, setAreaAddress] = useState<string>();
  const [areaAddressList, setAreaAddressList] = useState<TArea[]>([]);

  const [address, setAddress] = useState<string>('');
  const [urls, setUrls] = useState<FileDto[]>([]);
  const [areaList, setAreaList] = useState<TArea[]>([]);

  const [showPopup, setShowPopup] = useState<boolean>(false);
  const addressRef = useRef<HTMLTextAreaElement>(null);
  const wrapperRef = useRef<HTMLDivElement>(null);

  const [warrantyStatus, setWarrantyStatus] = useState<number>(0);
  const [warrantyEndTime, setWarrantyEndTime] = useState<string>('');
  const [warrantyURL, setWarrantyURL] = useState<string>('');

  const history = useHistory();
  const location = useLocation();
  const { search } = location;
  const equipmentCode = new URLSearchParams(search).get('equipmentCode');

  // 灯带描述
  const lightStripDescriptionList = [
    { name: '绿灯常亮', value: 1 },
    { name: '绿灯流水状', value: 2 },
    { name: '绿灯闪烁', value: 3 },
    { name: '黄灯常亮', value: 4 },
    { name: '红灯闪烁', value: 5 },
    { name: '指示灯灭', value: 6 },
    { name: '不同颜色间闪烁', value: 7 },
    { name: '其他情况', value: 20 }
  ];
  // 问题类型
  const problemTypeList = [
    { name: '车锁枪', value: 1 },
    { name: '无法启动充电', value: 6 },
    { name: '充电过程中断', value: 3 },
    { name: '充电慢', value: 2 },
    { name: '定时充电故障', value: 4 },
    { name: 'APP使用问题', value: 8 },
    { name: '外观损坏', value: 5 },
    { name: '施工线路故障', value: 9 },
    { name: '扫码绑定失败', value: 7 },
    { name: '充电桩迁移', value: 10 },
    { name: '其他问题', value: 99 }
  ];

  const isCanSubmit = useMemo<boolean>(() => {
    return (
      !!pileLightStatus &&
      !!problemType &&
      !!problemDesc &&
      !!contactName &&
      !!contactPhone &&
      !!areaAddress &&
      !!address
    );
  }, [
    pileLightStatus,
    problemType,
    problemDesc,
    contactName,
    contactPhone,
    areaAddress,
    address
  ]);

  const getAuth = () => {
    setLoading(true);
    go2LoginIfNot()
      .then(loginData => {
        if (!loginData) {
          Confirm.open('请先登录', {
            type: 2,
            confirmText: '确定',
            header: '',
            confirmCbk: (destroy): void => {
              destroy();
              // 关闭h5
              closeWindow();
            }
          });
        } else {
          // 已登录
          const phoneModel = getPlatform();
          let name: string = loginData.username;
          if (phoneModel === 'android') {
            name = loginData.nickname;
          }
          setAuthForMX(parseInt(loginData.uid));
          setNickname(name);
        }
        setLoading(false);
      })
      .catch(e => {
        console.log('页面出错', e.message);
        setLoading(false);
        closeWindow();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const foldProblemTypeList = (
    list: { name: string; value: number }[],
    isFold: boolean
  ) => {
    return list && isFold ? list.slice(0, 6) : list;
  };

  const handleChange = (urls: FileDto[]) => {
    setUrls(urls);
  };

  const onAreaAddressCancel = () => {
    if (wrapperRef.current) {
      wrapperRef.current.style.position = 'relative';
      wrapperRef.current.style.top = '0px';
      window.scrollTo({ top: scrollTop });
    }
    setShowPopup(false);
  };
  const showPicker = () => {
    setShowPopup(true);
    if (wrapperRef.current) {
      wrapperRef.current.style.position = 'fixed';
      wrapperRef.current.style.top = 0 - scrollTop + 'px';
    }
  };

  const onAreaAddressSure = (selectedIndexs: TArea[]) => {
    const tempAreaAddress = selectedIndexs.map(item => item.name).join('');
    setAreaAddress(tempAreaAddress);
    setAreaAddressList(selectedIndexs);
    setShowPopup(false);
  };

  const doConfirm =  async () => {
    let newUrls = urls.map(item => ({
      fileName: item.fileName,
      fileOssPath: item.fileOssPath,
    }));
    let userInfo = await getLoginInfoPromise()
    const reqParam = {
      uid: userInfo?.uid || uid,
      name: nickname,
      privatePileNo: equipmentCode || '',
      pileLightStatus: pileLightStatus,
      problemType: problemType,
      problemDesc: problemDesc,
      problemPicture: newUrls,
      contactName: contactName,
      contactPhone: contactPhone,
      province: areaAddressList[0].name,
      provinceCode: areaAddressList[0].adcode,
      city: areaAddressList[1].name,
      cityCode: areaAddressList[1].adcode,
      district: areaAddressList[2].name,
      districtCode: areaAddressList[2].adcode,
      address: address
    };
    setLoading(true);
    createAfterSaleOrder(reqParam)
      .then((result: any) => {
        const { code, msg, data } = result;
        if (![200, 0].includes(code)) {
          setLoading(false);
          console.log('服务器开小差:' + msg);
          Toast.show('暂时无法自助申请家充售后，请联系客服进行报修');
          return;
        }
        Toast.show('提交成功');
        setLoading(false);
        // 提交成功
        history.push({
          pathname: '/after-sales-service',
          search: '?orderNo=' + ((data && data.orderNo) ? data.orderNo : '')
        });
      })
      .catch((err: any) => {
        setLoading(false);
        Toast.show('暂时无法自助申请家充售后，请联系客服进行报修');
        console.log('err', err);
      });
  };

  const onSubmit = () => {
    if (
      !pileLightStatus ||
      !problemType ||
      !problemDesc ||
      !contactName ||
      !contactPhone ||
      !address ||
      !areaAddressList ||
      areaAddressList.length < 3
    ) {
      Toast.show('请确保准确填写信息');
      return;
    }
    if (!contactPhone || !PHONE_REG.test(contactPhone) || contactPhone.length !== 11 ) {
      Toast.show('请输入正确的手机号');
      return;
    }
    Confirm.open('确定提交申请吗？', {
      type: 2,
      confirmText: '确定',
      header: '',
      confirmCbk: (destroy): void => {
        destroy();
        doConfirm();
      }
    });
  };

  const getBaseInfo = async () => {
    try {
        let userInfo = await getLoginInfoPromise()
        getAfterSalePreInfo({ equipmentCode: equipmentCode || '', uid: userInfo?.uid || uid })
          .then((result: any) => {
            const { code, msg, data } = result;
            if (![200, 0].includes(code) || !data) {
              console.log('服务器开小差:' + msg);
              return;
            } else {
              const {
                contactName,
                contactPhone,
                province,
                provinceCode,
                city,
                cityCode,
                district,
                districtCode,
                address
              } = data;
              // 因为存在换桩延迟操作或漏操作的情况，导致默认信息不够准确，故去掉默认回填的信息
              // setContactName(contactName);
              // setContactPhone(contactPhone);
              // setAreaAddress(province + city + district);
              // setAddress(address);
              setAreaAddressList([
                {
                  name: province,
                  adcode: provinceCode
                },
                {
                  name: city,
                  adcode: cityCode
                },
                {
                  name: district,
                  adcode: districtCode
                }
              ]);
            }
          })
          .catch((err: any) => {
            console.log('err', err);
          });
    } catch (error) {
      console.error(error);
    }
  };

  const getAreaList = () => {
    axios({
      url: `${getAmapHost()}/v3/config/district`,
      data: {},
      params: {
        key: '6657470c50268b502426e5f406d1a444',
        subdistrict: 3,
        extensions: 'base'
      },
      method: 'GET'
    })
      .then((result: any) => {
        const { infocode, info, districts } = result.data;
        if (!['10000'].includes(infocode)) {
          console.log('服务器开小差:' + info);
          return;
        }
        let areaList =
          (districts && !!districts.length && districts[0].districts) ||
          ([] as TArea[]);
        let newAreaList = areaList.filter((item: TArea) => {
          return !['810000', '820000', '710000'].includes(
            item.adcode as string
          );
        });
        setAreaList(newAreaList);
      })
      .catch((err: any) => {
        console.log('err', err);
      });
  };

  //获取凭证状态
  const getWarrantyStatus = async () => {
    let userInfo = await getLoginInfoPromise()
    queryWarrantyStatus({ pileNo: equipmentCode || '', uid: userInfo?.uid || uid })
      .then((result) => {
          console.log(result,'data');
          setWarrantyStatus(result.warrantyStatus)
          setWarrantyEndTime(result.warrantyEndTime.split(' ')[0])
          setWarrantyURL(result.warrantyURL)
          console.log(warrantyURL)
      }).catch((err)=>{
        console.log(err);
      })
  }

  //跳转延保凭证
  const toWarrantyURL = () => {
    console.log(warrantyURL);
    openUrl(warrantyURL)
  }

  //渲染头部家桩保障部分
  const renderIsoverdue = () => {
    if (warrantyStatus === 2)
      return (
        <div className='header'>
          <div className='overdue greenbg overdue_center'>
            <div className='green_exclam_icon' />
            <div className='green_text'>质保期已过，可能收取费用，提交申请后家充管家将联系你并核对</div>
          </div>
        </div>
      )
    if (warrantyStatus === 1){
      if(warrantyURL){
          return (
            <div className='header'>
              <div className='overdue greybg overdue_bewteen'>
                <div className='overdue_flex'>
                  <div className='grey_exclam_icon' />
                  <div className='grey_text'>{`家充桩质保${warrantyEndTime ? warrantyEndTime: ' - - '}到期，到期前可延长`}</div>
                </div>
                <div className='green_text' onClick={() => toWarrantyURL()}>去延保</div>
              </div>
            </div>
          )
        }else{
          return (
            <div className='header'>
              <div className='overdue greybg'>
                <div className='overdue_flex'>
                  <div className='grey_exclam_icon' />
                  <div className='grey_text'>{`家充桩质保${warrantyEndTime ? warrantyEndTime: ' - - '}到期`}</div>
                </div>
              </div>
            </div>
          )
        }
    }
  }

  const handleAddressChange = e => {
    //关键是先设置为auto，目的为了重设高度（如果字数减少）
    if (addressRef.current) {
      addressRef.current.style.height = 'auto';
    }
    //如果高度不够，再重新设置
    if (
      addressRef.current &&
      addressRef.current.scrollHeight >= addressRef.current.offsetHeight
    ) {
      addressRef.current.style.height = addressRef.current.scrollHeight + 'px';
    }
    setAddress(e.target.value);
  };

  useEffect(() => {
    //监听页面尺寸变化
    addEventListener('resize', function() {
      // 解决键盘弹起后遮挡输入框的问题
      if (
        document.activeElement &&
        (document.activeElement.tagName == 'INPUT' ||
          document.activeElement.tagName == 'TEXTAREA')
      ) {
        window.setTimeout(function() {
          document.activeElement && document.activeElement.scrollIntoView();
        }, 0);
      }
    });
  }, []);

  useEffect(() => {
    getBaseInfo();
    // 判断当前是否已经登录
    getAuth();
    getAreaList();
    getWarrantyStatus();
    console.log(equipmentCode,'equipmentCode');

    document.title = '申请售后服务';
  }, []);

  useEffect(() => {
    if (loading) {
      FullLoading.show({
        text: '加载中'
      });
    } else {
      FullLoading.hide();
    }
  }, [loading]);

  return (
    <div className="after-sales" ref={wrapperRef}>
      {renderIsoverdue()}
      <div className="schedule">
        <div className="steps">
          <img src={check} alt="" className="stepsIcon"></img>
          <p className="liner2"></p>
          <img src={check} alt="" className="stepsIcon"></img>
          <p className="liner2"></p>
          <img src={check} alt="" className="stepsIcon"></img>
        </div>
        <div className="stepsTitle">
          <div className="text">申请售后</div>
          <div className="text">上门维修</div>
          <div className="text">完成&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>
        </div>
      </div>
      <div className="form">
        <div className="formItem">
          <div className="label required">指示灯显示情况:</div>
          <div className="radioWrap">
            {lightStripDescriptionList.map((item, index) => {
              return (
                <div key={index}>
                  <div
                    className={`${pileLightStatus === item.value ? 'checked' : 'radioItem'
                      }`}
                    onClick={() => setPileLightStatus(item.value)}
                  >
                    {item.name}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="formItem">
          <div className="label required">问题类型:</div>
          <div className="radioWrap">
            {foldProblemTypeList(problemTypeList, isFoldProblem).map(
              (item, index) => {
                return (
                  <div key={index}>
                    <div
                      className={`${
                        problemType === item.value ? 'checked' : 'radioItem'
                      }`}
                      onClick={() => setProblemType(item.value)}
                    >
                      {item.name}
                    </div>
                  </div>
                );
              }
            )}
          </div>
          {isFoldProblem ? (
            <div
              className="fold"
              onClick={() => {
                setIsFoldProblem(false);
              }}
            >
              <div className="foldText">展开</div>
              <div className="icon iconDown" />
            </div>
          ) : (
            <div
              className="fold"
              onClick={() => {
                setIsFoldProblem(true);
              }}
            >
              <div className="foldText">收起</div>
              <div className="icon iconUp" />
            </div>
          )}
        </div>
        <div className={'formItem'}>
          <div className="label required">问题描述:</div>
          <div className="question">
            <textarea
              className={'inputCode'}
              maxLength={100}
              rows={5}
              placeholder="请描述你遇到的问题"
              onChange={e => {
                setProblemDesc(e.target.value);
              }}
              value={problemDesc}
            />
          </div>
        </div>
        <div className="formItem spacing">
          <div className="label">上传图片:</div>
          <Uploade values={urls} onChange={handleChange} businessType="homechargeAftersalePicType" />
        </div>
        <div className="inputItem">
          <div className="label required">联系人姓名:</div>
          <input
            placeholder="请输入"
            maxLength={12}
            onChange={e => {
              if (e && e.target) {
                setContactName(e.target.value);
              }
            }}
            value={contactName}
          />
        </div>
        <div className="inputItem">
          <div className="label required">联系人电话:</div>
          <input
            placeholder="请输入"
            type="tel"
            maxLength={11}
            onChange={e => {
              if (e && e.target) {
                setContactPhone(e.target.value);
              }
            }}
            value={contactPhone}
          />
        </div>
        <div className="inputItem">
          <div className="label required">所在地区:</div>
          <div className="rightIcon" onClick={showPicker}>
            <div className={`addressValue ${areaAddress ? '' : 'default'}`}>
              {areaAddress ? areaAddress : '请选择'}
            </div>
            <img src={arrow} alt="" className="arrow"></img>
          </div>
        </div>
        <div className="inputItem">
          <div className="label required">详细安装地址:</div>
          <textarea
            ref={addressRef}
            placeholder="请输入"
            onChange={handleAddressChange}
            maxLength={400}
            rows={1}
            value={address}
          />
        </div>
      </div>
      <div className="footer">
        <button
          className={`${isCanSubmit ? 'submitBtn' : 'btnDisable'}`}
          onClick={isCanSubmit ? onSubmit : () => { }}
        >
          提交申请
        </button>
      </div>

      <CityPicker
        title="所在地区"
        show={showPopup}
        regionList={areaList}
        onCancel={onAreaAddressCancel}
        selectedIndexs={[0]}
        onSure={onAreaAddressSure}
      />
    </div>
  );
};

export default AfterSales;
